import React from 'react';

import Topbar from 'checkout/components/Topbar';
import styled, { css } from 'styled-components';
import { getPath } from 'src/routes/Checkout/store/selectors/router';
import { connect } from 'react-redux';
import {
  TOURISTS_PATH,
  PACKAGE_HOME_PATH,
} from 'src/routes/Checkout/store/constants';

import { getStepPath } from '../../utils/globalUtils';

const MobileHeader = ({ path }: PropsFromRedux): JSX.Element => (
  <Wrapper
    $isHomePath={getStepPath(path) === PACKAGE_HOME_PATH}
    $isTouristsPath={getStepPath(path) === TOURISTS_PATH}
  >
    <Topbar />
  </Wrapper>
);

const Wrapper = styled.div<{
  $isTouristsPath: boolean;
  $isHomePath: boolean;
}>`
  ${(props) => props.$isTouristsPath && `margin-bottom: 8px;`}

  ${(props) =>
    !props.$isHomePath &&
    css`
      position: sticky;
      top: 30px;
      z-index: 3;
    `}
`;

const mapStateToProps = (state) => ({
  path: getPath(state),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ReturnType<typeof mapStateToProps>;

export default connector(MobileHeader);
